import {
  DatePicker as AntdDatePicker,
  DatePickerProps as AntdDatePickerProps,
} from 'antd';

function DatePicker(props: AntdDatePickerProps) {
  return (
    <AntdDatePicker
      placeholder=""
      {...props}
      format="DD/MM/YYYY"
      style={{ width: '100%' }}
    />
  );
}

export default DatePicker;
